import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment-timezone";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../router/routes";
import { FontFamilySwitch } from "../../utils";
const useStyles = makeStyles((theme) => ({
  root: {},
  quotationId: {
    fontSize: "1rem",
    fontFamily: FontFamilySwitch().bold,
    color: theme.typography.color.primary,
  },
  time: {
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
    color: "#7C8594",
  },
  img: {
    // backgroundImage: "url(/images/avatarBlur.svg)",
    backgroundColor: theme.palette.primary.main,
    border: `0.5px solid ${theme.palette.primary.main}`,
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    padding: "4px",
  },
  img2: {
    backgroundColor: theme.palette.background.tertiary,
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    padding: "4px",
  },
  line: {
    color: theme.palette.border.secondary,
  },
  lineColor: {
    color: theme.palette.primary.main,
  },
}));

export const QuotationHistory = ({
  data = [],
  index = "",
  length,
  close = () => false,
  id = "",
  t = () => false
}) => {
  const classes = useStyles();
  const history = useHistory();
  const goPay = () => {
    history.push(Routes.quotationPayment);
  };

  return (
    <Link
      to={{
        pathname: `/quotation/${data.quotationNo}`,
      }}
      style={{ textDecoration: "none" }}
    >
      <div className={classes.root} onClick={close}>
        <Grid container alignItems="center">
          <Grid item xs={2}>
            {index !== 0 && (
              <Typography
                className={data.color ? classes.lineColor : classes.line}
              >
                &nbsp;&nbsp;&nbsp;|
              </Typography>
            )}
            {data.color && (
              <Avatar className={classes.img}>
                <img
                  src={
                    data.quotationId === "New"
                      ? "/images/tick.svg"
                      : "/images/clockWhite.svg"
                  }
                  alt="document"
                />
              </Avatar>
            )}
            {id === data.quotationNo ? (
              <Avatar className={classes.img}>
                <img src={"/images/regularDocument.svg"} alt="document" />
              </Avatar>
            ) : window.location.pathname === "/requestdetails" ? (
              ""
            ) : (
              <Avatar className={classes.img2}>
                <img src={"/images/clock.svg"} alt="document" />
              </Avatar>
            )}

            {index + 1 !== length && (
              <Typography
                className={data.color ? classes.lineColor : classes.line}
              >
                &nbsp;&nbsp;&nbsp;|
              </Typography>
            )}
          </Grid>
          <Grid item xs={9}>
            <div
              style={{
                marginBottom: index === 0 ? "16px" : "0px",
                marginTop: index + 1 === length ? "22px" : "0px",
              }}
            >
              <Typography className={classes.quotationId}>
                {t("Quotation")} #{data.quotationNo}
              </Typography>
              <Typography className={classes.time}>
                {" "}
                {t("Received on")}&nbsp;
                {moment(data.createdOn)
                  .tz(moment.tz.guess())
                  .format("YYYY-MM-DD hh:mm A")}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={1} textAlign="center" alignSelf="auto">
            {data.status ? (
              <IconButton onClick={goPay}>
                <img src="/images/arrowPath.svg" alt="arrow" />
              </IconButton>
            ) : null}
          </Grid>
        </Grid>
      </div>
    </Link>
  );
};
